export default "__VITE_ASSET__BVdOvUPp__"